import React, { Suspense } from 'react';
import { Switch, HashRouter , Route, Redirect } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import Navbar from './Navbar';
import routes from './routes';
import TopNavbar from './TopNavbar';
import { GetFeatures, prefix } from './MojaveLib';

const DefaultLayout = (props) => {

    const features = JSON.parse(GetFeatures());

    const history = createBrowserHistory({
        basename: `/${prefix()}/`
    }) 

    return (
        <div id="body" className="theme-cyan">

            <TopNavbar />

            <Navbar />

            <Suspense fallback={<div>Loading...</div>}>
                <HashRouter>
                    <Switch>
                        {routes.map((route, idx) => {
                            return route.component && ((features[`${route.menu}`] !== undefined 
                            && route.submenu !== '' && features[`${route.menu}`].includes(parseInt(route.submenu))) 
                            || parseInt(route.menu) === 0) ? (
                            <Route exact key={Math.random()} path={route.path} name={`${route.name}`} render={props => (
                                <route.component {...props} key={Math.random()} />
                                )} />
                            ) : (null);
                        })}
                        <Route exact path="/" render={() => <Redirect to="/dashboard/home" />} />
                        <Route render={() => <Redirect to="/dashboard/home" />} />
                    </Switch>
                </HashRouter>
            </Suspense>
        </div>
    );
}

export default DefaultLayout;